module.exports = __webpack_public_path__ + "src/routes/visualChart/components/Logo/logo.svg?5b0d9b84";


//////////////////
// WEBPACK FOOTER
// ./src/routes/visualChart/components/Logo/logo.svg
// module id = 2874
// module chunks = 1